// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1H8iw","name":"Header_name__3A_KU","birthday":"Header_birthday__39pDU","skeleton":"Header_skeleton__39eqf"};